msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fa\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-27 06:16\n"
"Last-Translator: \n"
"Language-Team: Persian\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: fa\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "قفل شده"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "فرسته‌ها: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "آخرین فرسته‌ها: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "خودکارشده"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1438
msgid "Group"
msgstr "گروه"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "متقابل"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "درخواست‌شده"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "پی‌گرفته"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "شما را پی میگیرد"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural,one {# پی‌گرفته} other {# پی‌گرفته‌ها}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "تاییدشده"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "عضو شده<0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "برای همیشه"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "ناتوان در بارگذاری حساب کاربری."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "برو به صفحهٔ حساب کاربری"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "پی‌گیرنده"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "فرسته"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "بیشتر"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr ""

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr ""

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr ""

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr ""

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "برو به صفحهٔ اصلی نمایه"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "نمایش تصویر نمایه"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "نمایش سرآیند نمایه"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "در یادبود"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "این کاربر انتخاب کرده که این اطلاعات در دسترس نباشد."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} فرسته‌های اصلی، {1} پاسخ‌ها، {2} تقویت‌ها"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {۱ فرستهٔ آخر در ۱ روز گذشته} other {۱ فرستهٔ آخر در {2} روز گذشته}}} other {{3, plural, one {{4} فرستهٔ آخر در ۱ روز گذشته} other {{5} فرستهٔ آخر در {6} روز گذشته}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {۱ فرستهٔ آخر در سال گذشته} other {{1} فرستهٔ آخر در سال گذشته}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "اصلی"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1412
#: src/pages/catchup.jsx:2023
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "پاسخ‌ها"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1414
#: src/pages/catchup.jsx:2035
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "تقویت‌ها"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "اطلاعات فرسته غیرقابل دسترسی."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "نمایش اطلاعات فرسته"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "آخرین فرسته: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "خموشانده"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "مسدودشده"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "یادداشت خصوصی"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "اشاره به <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "ترجمهٔ شرح حال"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "ویرایش یادداشت خصوصی"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "افزودن یادداشت خصوصی"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "آگاهی‌ها برای فرسته‌های @{username} فعال شدند."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "آگاهی‌ها برای فرسته‌های @{username} غیرفعال شدند."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "غیرفعال کردن آگاهی‌ها"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "فعال‌سازی آگاهی‌ها"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "تقویت‌های @{username} فعال شدند."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "تقویت‌های @{username} غیرفعال شدند."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "غیرفعال کردن تقویت‌ها"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "فعال کردن تقویت‌ها"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "افزودن/حذف کردن از سیاهه‌ها"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "پیوند رونوشت شد"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "ناتوان در رونوشت برداشتن از پیوند"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "رونوشت"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "انگار همرسانی کار نمیکند."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "همرسانی…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "ناخموشیده @{username}"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "ناخموشاندن <0>@{username}</0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "خموشاندن <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "@{username} برای {0} خموشیده"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "ناتوانی در خموشاندن @{username}"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "<0>@{username}</0> را از پی‌گرفتگان حذف میکنید؟"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} از پی‌گیرنده حذف شد"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "حذف کردن پی‌گرفته…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr ""

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "نامسدود کردن @{username}"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "@{username} مسدود شد"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "ناتوانی در نامسدود کردن @{username}"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "ناتوانی در مسدود کردن @{username}"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr ""

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr ""

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr ""

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "ویرایش نمایه"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "برگرداندن درخواست پی‌گیری؟"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "پی نگرفتن @{0}؟"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "پی نگرفتن…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "برگرداندن…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "پی گرفتن"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1548
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "بستن"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "شرح حال ترجمه شد"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "ناتوانی در حذف از سیاهه."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "ناتوانی در افزودن به سیاهه."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "ناتوانی در بارگذاری سیاهه‌ها."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "سیاهه‌ای نیست."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "سیاهه جدید"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr ""

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "ناتوانی در بروزرسانی یادداشت خصوصی."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "لغو"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "ذخیره و بستن"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "ناتوانی در بروزرسانی نمایه."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "شرح حال"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "مورد اضافی"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "برچسب"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "محتوا"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "ذخیره"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "نام کاربری"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "سامانهٔ نام دامنه"

#: src/components/background-service.jsx:138
msgid "Cloak mode disabled"
msgstr ""

#: src/components/background-service.jsx:138
msgid "Cloak mode enabled"
msgstr ""

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:431
#: src/pages/catchup.jsx:860
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "خانه"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "ترکیب"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "شما تغییرات ذخیره‌نشده دارید. این فرسته را رها میکنید؟"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr ""

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr ""

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "کوچک‌کردن"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "انگار شما پنجرهٔ اصلی را بستید."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr ""

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr ""

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr ""

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "درحال پاسخ دادن به فرستهٔ @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "درحال پاسخ دادن به فرستهٔ @{0}"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "ویرایش فرستهٔ منبع"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "نظرسنجی حداقل باید ۲ گزینه داشته باشد"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "بعضی گزینه‌های نظرسنجی خالی هستند"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "بعضی از رسانه‌ها شرح ندارند. ادامه میدهید؟"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "پیوست #{i} شکست خورد"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:975
msgid "Content warning"
msgstr "هشدار محتوا"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "هشدار محتوا یا رسانهٔ حساس"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "همگانی"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "فهرست‌نشده"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "فقط پی‌گیرنده"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "اشارهٔ خصوصی"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "پاسختان را بفرستید"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "فرسته‌تان را ویرایش کنید"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "چکار میکنید؟"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "علامت‌گذاری رسانه به عنوان حساس"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "افزودن نظرسنجی"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "افزودن شکلک شخصی‌سازی‌شده"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "پاسخ دادن"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "بروزرسانی"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr ""

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "بارگیری جیف…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "بارگیری جیف ناموفق بود"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "بیشتر…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "بارگذاری شد"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "شرح تصویر"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "شرح ویدئو"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "شرح صدا"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr ""

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr ""

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr ""

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1058
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr ""

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr ""

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr ""

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr ""

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr ""

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "تولید شرح. لطفا صبر کنید…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "شکست در تولید شرح: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "شکست در تولید شرح"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "تولید شرح…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "شکست در تولید شرح{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— آزمایشگاهی</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "اتمام"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "گزینه {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "گزینه‌های چندگانه"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "طول"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "حذف نظرسنجی"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "جستجوی حساب‌ها"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "افزودن"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "خطا در بارگذاری حساب‌ها"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "شکلک‌های شخصی‌سازی‌شده"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "جستجوی شکلک"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "خطا در بارگذاری شکلک‌های شخصی‌سازی‌شده"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "اخیرا استفاده‌شده"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "دیگران"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} بیشتر…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "جستجوی جیف‌ها"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "قدرت‌گرفته از GIPHY"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "برای جستجوی جیف‌ها بنویسید"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:880
msgid "Previous"
msgstr "پیشین"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:897
msgid "Next"
msgstr "پسین"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "خطا در بارگذاری جیف‌ها"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "پیش‌نویس‌های ارسال‌نشده"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "انگار پیش‌نویس‌های ارسال‌نشده دارید. بیایید از جایی که رها کرده‌اید ادامه دهیم."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "این پیش‌نویس را حذف میکنید؟"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "خطا در حذف پیش‌نویس! لطفا دوباره تلاش کنید."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "حذف…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr ""

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "حذف کل پیش‌نویس‌ها؟"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "خطا در حذف پیش‌نویس‌ها! لطفا دوباره تلاش کنید."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "حذف همه…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "پیش‌نویسی یافت نشد."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1895
msgid "Poll"
msgstr "نظرسنجی"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "رسانه"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "باز کردن در پنجره‌ای جدید"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "قبول کردن"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "رد کردن"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "قبول شده"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "رد شده"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "چیزی برای نمایش نیست"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "حساب‌های کاربری"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:513
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "نمایش بیشتر…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:518
#: src/pages/search.jsx:459
msgid "The end."
msgstr "آخر."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1586
msgid "Keyboard shortcuts"
msgstr "میانبرهای صفحه کلید"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "راهنمای میانبرهای صفحه کلید"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1611
msgid "Next post"
msgstr "فرستهٔ پسین"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1619
msgid "Previous post"
msgstr "فرستهٔ پیشین"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>دگرساز</0> + <1>ت</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>دگرساز</0> + <1>ن</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "بارگذاری فرسته‌های جدید"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1643
msgid "Open post details"
msgstr "باز کردن اطلاعات فرسته"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>ورود</0> یا <1>خ</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "گسترش دادن هشدار محتوا یا<0/>تغییر حالت رشتهٔ گسترده/بسته"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "بستن فرسته یا پنجره"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>فرار</0> یا <1>پس‌بر</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "ستون متمرکز در حالت چندستونه"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>۱</0> تا <1>۹</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "نوشتن فرستهٔ جدید"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "نوشتن فرستهٔ جدید (پنجرهٔ جدید)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>دگرساز</0> + <1>ز</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "ارسال فرسته"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>مهار</0> + <1>ورود</1> یا <2>⌘</2> + <3>ورود</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "جستجو"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "پاسخ دادن (پنجرهٔ جدید)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>دگرساز</0> + <1>ق</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "پسندیدن (مورد علاقه)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>م</0> یا <1>ب</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "تقویت کردن"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>دگرساز</0> + <1>ذ</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "نشانک‌گذاری"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>تبدیل</0> + <1>دگرساز</1> + <2>ن</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "ویرایش سیاهه"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "ناتوان در ویرایش سیاهه."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "ناتوان در ایجاد سیاهه."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "نام"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "نمایش پاسخ‌ها به سیاههٔ اعضا"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "نمایش پاسخ‌ها به افرادی که پی میگیرم"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "پاسخ‌ها را نمایش نده"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "پنهان کردن فرسته‌ها در این سیاهه از خانه/پی‌گرفته"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "ایجاد"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "این سیاهه را حذف میکنید؟"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "ناتوان در حذف سیاهه."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "شرح رسانه"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "ترجمه"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "حرف زدن"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "باز کردن رسانهٔ اصلی در پنجرهٔ جدید"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "باز کردن رسانهٔ اصلی"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "تلاش برای شرح دادن تصویر. لطفا صبر کنید…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "شکست در شرح دادن تصویر"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "شرح دادن تصویر…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "نمایش فرسته"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "رسانهٔ حساس"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "پالایش‌شده: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:964
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1843
msgid "Filtered"
msgstr "پالایش‌شده"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "فرسته منتشر شد. آن را ببینید."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "پاسخ ارسال شد. آن را ببینید."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "فرسته بروزرسانی شد. آن را ببینید."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "فهرست"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "صفحه را برای بروزرسانی بارگذاری مجدد میکنید؟"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "بروزرسانی جدید در دسترس است…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:855
msgid "Catch-up"
msgstr ""

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "اشاره‌ها"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "آگاهی‌ها"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "جدید"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "نمایه"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "سیاهه‌ها"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "همهٔ سیاهه‌ها"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "نشانک‌گذاری‌ها"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1413
#: src/pages/catchup.jsx:2029
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "برگزیده‌ها"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "برچسب‌های پی‌گرفته‌شده"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "پالایه‌ها"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "کاربران خموشیده‌شده"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "کاربران خموشیده‌شده…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "کاربران مسدودشده"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "کاربران مسدودشده…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "حساب‌ها…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "ورود"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "داغ"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "محلی"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "خودگردان"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "میانبرها / ستون‌ها…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "تنظیمات…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "آگاهی"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "این آگاهی از حساب دیگر شماست."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "نمایش همهٔ آگاهی‌ها"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} روی فرستهٔ شما با {emojiObject} بازخورد داد"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} یک فرسته منتشر کرد."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr ""

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} درخواست کرد شما را پی‌گیری کند."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "یک نظرسنجی که در آن رأی داده‌اید یا آن را ایجاد کرده‌اید پایان یافته است."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "یک نظرسنجی که شما ایجاد کرده‌اید پایان یافته است."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "یک نظرسنجی که شما در آن رأی داده‌اید پایان یافته است."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "یک فرسته که شما با آن تعامل داشته‌اید تغییر یافته است."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} ثبت‌نام شد."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} {targetAccount} را گزارش کرد"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "اتصال از دست رفته با <0>{name}</0>."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr ""

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "یک مدیر از <0>{from}</0> <1>{targetName}</1> را تعلیق کرده است، معنی‌اش این است که شما دیگر نمیتوانید بروزرسانی‌هایی از آنها دریافت کنید یا با آنها تعامل کنید."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "یک مدیر از <0>{from}</0> <1>{targetName}</1> را مسدود کرده است. پی‌گیرنده‌های تأثیرپذیرفته: {followersCount}، پی‌گرفته‌های تأثیرپذیرفته: {followingCount}."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "شما <0>{targetName}</0> را مسدود کرده‌اید. پی‌گیرنده حذف‌شده: {followersCount}، پی‌گرفته‌های حذف‌شده: {followingCount}."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr ""

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "حساب کاربری شما غیرفعال شده است."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "بعضی از فرسته‌های شما به عنوان حساس نشانه‌گذاری شده‌اند."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "بعضی از فرسته‌های شما حذف شده‌اند."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "از این به بعد فرسته‌های شما به عنوان حساس نشانه‌گذاری خواهند شد."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "حساب کاربری شما محدود شده است."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "حساب کاربری شما تعلیق شده است."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[نوع ناشناختهٔ آگاهی: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "تقویت‌شده/برگزیده‌شده توسط…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "برگزیده‌شده توسط…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "تقویت‌شده توسط…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "پی‌گرفته‌شده توسط…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "بیشتر بدانید <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "بیشتر خوانید ←"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "رأی داده شده"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "پنهان کردن نتایج"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "رأی دادن"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "بارگذاری مجدد"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "نمایش نتایج"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr ""

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr ""

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "پایان یافته <0/>"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "پایان‌یافته"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "در حال اتمام <0/>"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "در حال اتمام"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}ث"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}د"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}س"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr ""

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr ""

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr ""

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr ""

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr ""

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "قوانین خاص کارساز را نقض میکند"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr ""

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "دیگر"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr ""

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "گزارش دادن فرسته"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "گزارش دادن @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr ""

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "فرسته گزارش شد"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "نمایه گزارش شد"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "ناتوان در گزارش دادن فرسته"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "ناتوان در گزارش دادن نمایه"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "مشکل این فرسته چیست؟"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "مشکل این نمایه چیست؟"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "اطلاعات اضافی"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "هدایت کرد نبه <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "ارسال کردن گزارش"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "خموشیده {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr ""

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr ""

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr ""

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr ""

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr ""

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ حساب‌های کاربری، برچسب‌ها و فرسته‌ها</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "فرسته‌هایی با <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "فرسته‌هایی که با <0>#{0}</0> برچسب‌گذاری شده‌اند"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "بررسی کردن <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "حساب‌های کاربری با <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "خانه/پی‌گرفته"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "همگانی (محلی/نامتمرکز)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "حساب کاربری"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "برچسب"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "شناسهٔ سیاهه"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "فقط محلی"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "نمونه"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "پیشنهادی، مثلا mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr ""

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "مثلا PixelArt (حداکثر ۵، جدا شده با فاصله)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "فقط رسانه"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "میانبرها"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "بتا"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "تعیین کردن سیاهه‌ای از میانبرهایی که به عنوان ظاهر میشوند:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "دکمهٔ شناور"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "نوار برگه/فهرست"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "چندستونه"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "غیرقابل دسترسی در حالت نمایش کنونی"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "حرکت به بالا"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "حرکت به پایین"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "ویرایش"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "یک میانبر/ستون دیگر اضافه کنید تا این کار کند."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "هنوز ستونی وجود ندارد. روی دکمهٔ افزودن ستون بزنید."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "هنوز میانبری وجود ندارد. روی دکمهٔ افزودن میانبر بزنید."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr ""

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "بیشترین {SHORTCUTS_LIMIT} ستون"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "بیشترین {SHORTCUTS_LIMIT} میانبر"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "ورود/صدور"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "افزودن ستون…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "افزودن میانبر…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "سیاههٔ مخصوص پیشنهادی است. برای حالت چندستونه، سیاهه ضروری است، در غیر این صورت این ستون میتواند نمایش داده نشود."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "چندبرچسب پشتیبانی میشود. جداشده با فاصله."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "ویرایش میانبر"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "افزودن میانبر"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "خط زمانی"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "سیاهه"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "ورود/صدور <0>میانبرها</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "ورود"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "چسباندن میانبرها اینجا"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "بارگیری میانبرهای ذخیره‌شده از کارساز نمونه…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "ناتوان در بارگیری میانبرها"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "بارگیری میانبرها از کارساز نمونه"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr ""

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr ""

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr ""

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr ""

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr ""

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr ""

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "بازنویسی کردن…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "وارد کردن…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "صادر کردن"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "میانبرها رونوشت شدند"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "ناتوان در رونویسی از میانبرها"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "میانبرهای تنظیمات رونوشت شدند"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "ناتوان در رونویسی از میانبرهای تنظیمات"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "همرسانی"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "ذخیره کردن میانبرها در کارساز نمونه…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "میانبرها ذخیره شدند"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "ناتوان در ذخیره کردن میانبرها"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "همگام‌سازی با کارساز نمونه"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural,one {# نویسه} other {# نویسه‌ها}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "جیسون خالص میانبرها"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "ورود/صدور تنظیمات از/به کارساز نمونه (خیلی آزمایشی)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>تقویت‌شده</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "متأسفانه نمونه‌ای که شما در آن وارد شده‌اید نمیتواند با این فرسته از یک نمونهٔ دیگر تعامل داشته باشد."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "فرستهٔ @{0} نابرگزیده شد"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "فرستهٔ @{0} برگزیده شد"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "فرستهٔ @{0} نانشانک‌گذاری شد"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "فرستهٔ @{0} نشانک‌گذاری شد"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "ناتقویت"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "نقل قول"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "بعضی از رسانه‌ها شرح ندارند."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "فرستهٔ قدیمی (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "فرستهٔ @{0} ناتقویت شد"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "فرستهٔ @{0} تقویت شد"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "تقویت…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "نابرگزیدن"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "برگزیدن"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "نانشانک‌گذاری"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "نمایش تاریخچهٔ ویرایش"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "ویرایش‌شده: {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "فرستهٔ جاسازی‌شده"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "گفتگو ناخموشیده شد"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "گفتگو خموشیده شد"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "ناتوان در ناخموشاندن گفتگو"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "ناتوان در خموشاندن گفتگو"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "ناخموشاندن گفتگو"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "خموشاندن گفتگو"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "سنجاق فرسته از نمایه برداشته شد"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "فرسته به نمایه سنجاق شد"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "ناتوان در برداشتن سنجاق فرسته"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "ناتوان در سنجاق کردن فرسته"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr ""

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr ""

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr ""

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr ""

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr ""

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr ""

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr ""

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr ""

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr ""

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr ""

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr ""

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr ""

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr ""

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr ""

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr ""

#: src/components/status.jsx:2071
msgid "Show media"
msgstr ""

#: src/components/status.jsx:2191
msgid "Edited"
msgstr ""

#: src/components/status.jsx:2268
msgid "Comments"
msgstr ""

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr ""

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr ""

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr ""

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr ""

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr ""

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr ""

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr ""

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr ""

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr ""

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr ""

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr ""

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr ""

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr ""

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr ""

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr ""

#: src/components/status.jsx:3254
msgid "Preview"
msgstr ""

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "نکته: این پیش‌نمایش بصورت طراحی سبک است."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> تقویت‌شده"

#: src/components/timeline.jsx:447
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "فرسته‌های جدید"

#: src/components/timeline.jsx:548
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "تلاش مجدد"

#: src/components/timeline.jsx:937
#: src/components/timeline.jsx:944
#: src/pages/catchup.jsx:1860
msgid "Thread"
msgstr "رشته"

#: src/components/timeline.jsx:959
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>پالایش‌شده</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "ترجمهٔ خودکار از {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "درحال ترجمه…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "ترجمه از {sourceLangText} (تشخیص خودکار)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "ترجمه از {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "خودکار ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "شکست در ترجمه"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "ویرایش وضعیت منبع"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "درحال پاسخ دادن به @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "احتمالا باید این صفحه را الآن ببندید."

#: src/compose.jsx:70
msgid "Close window"
msgstr "بستن پنجره"

#: src/compose.jsx:86
msgid "Login required."
msgstr ""

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "رفتن به خانه"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "فرسته‌های حساب کاربری"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ پاسخ‌ها)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- تقویت‌ها)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (رسانه)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "پاک کردن پالایه‌ها"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "پاک کردن"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "نمایش فرسته با پاسخ‌ها"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ پاسخ‌ها"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "نمایش فرسته‌ها بدون تقویت‌ها"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- تقویت‌ها"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "نمایش فرسته‌های دارای رسانه"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "نمایش فرسته‌هایی که با #{0} برچسب‌گذاری شده‌اند"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "نمایش فرسته‌ها در {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "اینجا چیزی برای دیدن نیست."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "ناتوان در بارگذاری فرسته‌ها"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr ""

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "انتقال به نمونهٔ حساب کاربری {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "انتقال به نمونهٔ من (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "ماه"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "کنونی"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "پیش‌گزیده"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr ""

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "نمایش نمایه…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "تنظیم به عنوان پیش‌گزیده"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "از <0>@{0}</0> خارج میشوید؟"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "خروج…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "افزودن یک حساب کاربری موجود"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr ""

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "ناتوان در بارگذاری نشانک‌ها."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "۱ ساعت گذشته"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "۲ ساعت گذشته"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "۳ ساعت گذشته"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "۴ ساعت گذشته"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "۵ ساعت گذشته"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "۶ ساعت گذشته"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "۷ ساعت گذشته"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "۸ ساعت گذشته"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "۹ ساعت گذشته"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "۱۰ ساعت گذشته"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "۱۱ ساعت گذشته"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "۱۲ ساعت گذشته"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr ""

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "برچسب‌های پی‌گرفته‌شده"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "گروه‌ها"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr ""

#: src/pages/catchup.jsx:866
#: src/pages/catchup.jsx:890
msgid "Catch-up <0>beta</0>"
msgstr ""

#: src/pages/catchup.jsx:880
#: src/pages/catchup.jsx:1552
msgid "Help"
msgstr "راهنما"

#: src/pages/catchup.jsx:896
msgid "What is this?"
msgstr "اين چيست؟"

#: src/pages/catchup.jsx:899
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr ""

#: src/pages/catchup.jsx:910
msgid "Preview of Catch-up UI"
msgstr ""

#: src/pages/catchup.jsx:919
msgid "Let's catch up"
msgstr ""

#: src/pages/catchup.jsx:924
msgid "Let's catch up on the posts from your followings."
msgstr ""

#: src/pages/catchup.jsx:928
msgid "Show me all posts from…"
msgstr "تمام فرسته‌های… را به من نشان بده"

#: src/pages/catchup.jsx:951
msgid "until the max"
msgstr "تا بیشترین"

#: src/pages/catchup.jsx:981
msgid "Catch up"
msgstr ""

#: src/pages/catchup.jsx:987
msgid "Overlaps with your last catch-up"
msgstr ""

#: src/pages/catchup.jsx:999
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1008
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "نکته: نمونهٔ شما فقط میتواند حداکثر ۸۰۰ فرسته بدون توجه به زمان در خط زمانی نمایش دهد. میتواند کمتر یا بیشتر باشد."

#: src/pages/catchup.jsx:1018
msgid "Previously…"
msgstr "قبلا…"

#: src/pages/catchup.jsx:1036
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural,one {# فرسته} other {# فرسته‌ها}}"

#: src/pages/catchup.jsx:1046
msgid "Remove this catch-up?"
msgstr ""

#: src/pages/catchup.jsx:1067
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr ""

#: src/pages/catchup.jsx:1082
msgid "Fetching posts…"
msgstr ""

#: src/pages/catchup.jsx:1085
msgid "This might take a while."
msgstr "این کمی زمانبر است."

#: src/pages/catchup.jsx:1120
msgid "Reset filters"
msgstr "تنظیم مجدد پالایه‌ها"

#: src/pages/catchup.jsx:1128
#: src/pages/catchup.jsx:1558
msgid "Top links"
msgstr "برترین پیوندها"

#: src/pages/catchup.jsx:1244
msgid "Shared by {0}"
msgstr "همرسانی‌شده توسط {0}"

#: src/pages/catchup.jsx:1283
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "همه"

#: src/pages/catchup.jsx:1368
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural,one {# نویسنده} other {# نویسنده‌ها}}"

#: src/pages/catchup.jsx:1380
msgid "Sort"
msgstr "مرتب‌سازی"

#: src/pages/catchup.jsx:1411
msgid "Date"
msgstr "تاریخ"

#: src/pages/catchup.jsx:1415
msgid "Density"
msgstr "تراکم"

#: src/pages/catchup.jsx:1453
msgid "Authors"
msgstr "نویسنده‌ها"

#: src/pages/catchup.jsx:1454
msgid "None"
msgstr "هیچ‌کدام"

#: src/pages/catchup.jsx:1470
msgid "Show all authors"
msgstr "نمایش همهٔ نویسنده‌ها"

#: src/pages/catchup.jsx:1521
msgid "You don't have to read everything."
msgstr "نیازی نیست همه چیز را بخوانید."

#: src/pages/catchup.jsx:1522
msgid "That's all."
msgstr "کافیست."

#: src/pages/catchup.jsx:1530
msgid "Back to top"
msgstr "برگشتن به بالا"

#: src/pages/catchup.jsx:1561
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "پیوندهایی که توسط پی‌گرفته‌ها همرسانی شده‌اند، مرتب‌شده طبق شمارش همرسانی‌شده، تقویت‌ها و برگزیده‌ها."

#: src/pages/catchup.jsx:1567
msgid "Sort: Density"
msgstr "مرتب‌سازی: تراکم"

#: src/pages/catchup.jsx:1570
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "فرسته‌ها با تراکم یا عمق اطلاعات مرتب‌شده‌اند. فرسته‌های کوتاه‌تر «سبک‌تر» هستند درحالیکه فرسته‌های طولانی‌تر «سنگین‌تر» هستند. فرسته‌هایی با تصاویر از فرسته‌های بدون تصویر «سنگین‌تر» هستند."

#: src/pages/catchup.jsx:1577
msgid "Group: Authors"
msgstr "گروه: نویسندگان"

#: src/pages/catchup.jsx:1580
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "فرسته‌ها طبق نویسنده‌ها دسته‌بندی شده‌اند، طبق فرسته بر حسب نویسنده مرتب شده‌اند."

#: src/pages/catchup.jsx:1627
msgid "Next author"
msgstr "نویسندهٔ پسین"

#: src/pages/catchup.jsx:1635
msgid "Previous author"
msgstr "نویسندهٔ پیشین"

#: src/pages/catchup.jsx:1651
msgid "Scroll to top"
msgstr "پیمایش به بالا"

#: src/pages/catchup.jsx:1842
msgid "Filtered: {0}"
msgstr "پالایش‌شده: {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "ناتوان در بارگذاری برگزیده‌ها."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "خانه و سیاهه‌ها"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "خط زمانی همگانی"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "گفتگوها"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "نمایه‌ها"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "هرگز"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "پالایهٔ جدید"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural,one {# پالایه} other {# پالایه‌ها}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "ناتوان در بارگذاری پالایه‌ها."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "هنوز پالایه‌ای نیست."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "اصافه کردن پالایه"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "ویرایش پالایه"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "ناتوان در ویرایش پالایه"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "ناتوان در ایحاد پالایه"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "عنوان"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "تمام واژه"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "کلیدواژهای نیست. یکی اضافه کنید."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "افزودن کلیدواژه"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr ""

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr ""

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr ""

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr ""

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr ""

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr ""

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr ""

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr ""

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr ""

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "هرگز منقضی نمیشود"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# برچسب} other {# برچسب‌ها}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "ناتوان در بارگذاری برچسب‌های پی‌گرفته."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "هنوز برچسبی پی‌گرفته نشده."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "اینجا چیزی برای دیدن وجود ندارد."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "ناتوان در بارگذاری فرسته‌ها."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (فقط رسانه) در {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} در {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (فقط رسانه)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "هنوز کسی با این برچسب چیزی نفرستاده است."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "ناتوان در بارگذاری فرسته‌ها با این برچسب"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} ناپی‌گرفته شد"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "#{hashtag} پی‌گرفته شد"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "درحال پی‌گیری…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr ""

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {بیشترین # برچسب‌ها}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "افزودن برچسب"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "حذف کردن برچسب"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "این میانبر درحال حاضر موجود است"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "میانبر برچسب اضافه شد"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "افزودن به میانبرها"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "یک نمونهٔ جدید وارد کنید مثل \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "نمونهٔ نامعتبر"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "رفتن به یک نمونهٔ دیگر…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "رفتن به نمونهٔ من (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>جدید</0> <1>درخواست‌های پی‌گیری</1>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "دیدن همه"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "هنوز چیزی نیست."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "مدیریت کردن اعضا"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "<0>@{0}</0> را از سیاهه حذف میکنید؟"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "حذف کردن…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# سیاهه} other {# سیاهه‌ها}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "هنوز سیاهه‌ای نیست."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "مثلا \"mastodon.social\""

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr "ادامه دادن با {selectedInstanceText}"

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "ادامه"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "حساب کاربری ندارید؟ یکی بسازید!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "اشاره‌های خصوصی"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "خصوصی"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "کسی به شما اشاره نکرده :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr ""

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr ""

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr ""

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr ""

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr ""

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr ""

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr ""

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "درخواست‌های پی‌گیری"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# درخواست پی‌گیری} other {# درخواست پیگیری}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {آگاهی‌های پالایش‌شده از شخص #} other {آگاهی‌های پالایش‌شده از شخص #}}"

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "فقط اشاره‌ها"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "امروز"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "دیروز"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "ناتوان در بارگذاری آگاهی‌ها"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "تنظیمات آگاهی‌ها بارگذاری شدند"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "پالایش کردن آگاهی‌ها از افراد:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "پالایش کردن"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "نادیده گرفتن"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "بروزشده <0>{0}</0>"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr "نمایش آگاهی‌ها از <0>@{0}</0>"

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr "آگاهی‌ها از <0>@{0}</0>"

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "آگاهی‌ها از @{0} از الآن پالایش نخواهند شد."

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr "ناتوان در قبول کردن درخواست آگاهی"

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "اجازه دادن"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "آگاهی‌ها از @{0} از الآن در آگاهی‌های پالایش‌شده نمایش داده نخواهند شد."

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr "ناتوان در رد کردن درخواست آگاهی"

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "رد کردن"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr "رد شد"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "خط زمانی محلی ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "خط زمانی نامتمرکز ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "خط زمانی محلی"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "خط زمانی نامتمرکز"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "هنوز کسی چیزی ارسال نکرده است."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "تعویض کردن به نامتمرکز"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "تعویض کردن به محلی"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "جستجو: {q} (فرسته‌ها)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "جستجو: {q} (حساب‌های کاربری)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "جستجو: {q} (برچسب‌ها)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "جستجو: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "برچسب‌ها"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "بیشتر ببینید"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "حساب‌های کاربری بیشتری را ببینید"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "حسابی یافت نشد."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "دیدن برچسب‌های بیشتر"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "برچسبی پیدا نشد."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "دیدن فرسته‌های بیشتر"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "فرسته‌ای پیدا نشد."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "تنظیمات"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "ظاهر"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "روشن"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "تاریک"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "خودکار"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "اندازهٔ نوشته"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr ""

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "نمایش زبان"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr "ترجمه‌های داوطلبانه"

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "درحال ارسال"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr ""

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "همگام‌سازی شد"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr ""

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "با تنظیمات کارساز نمونهٔ شما همگام‌سازی شد. <0> برای تنظیمات بیشتر به نمونهٔ خود ({instance}) بروید.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "آزمایش‌ها"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "بارگذاری مجدد خودکار فرسته‌های خط زمانی"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "ترجمهٔ فرسته"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "ترجمه به"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "زبان سامانه ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {مخفی کردن دکمهٔ «ترجمه» برای:} other {مخفی کردن دکمهٔ «ترجمه» برای (#):}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr ""

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr "ترجمهٔ خودکار درخط"

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr ""

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr ""

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr ""

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr ""

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:692
msgid "About"
msgstr ""

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr ""

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr ""

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr ""

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr ""

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr ""

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr ""

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr ""

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr ""

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr ""

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:999
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr ""

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr ""

#: src/pages/status.jsx:565
msgid "Post"
msgstr "ارسال"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr ""

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr ""

#: src/pages/status.jsx:1048
msgid "Back"
msgstr ""

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr ""

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr ""

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr ""

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr ""

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr ""

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr ""

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr ""

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr ""

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr ""

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr ""

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr ""

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""

